import gql from "graphql-tag";

export const create = gql`
  mutation CreateProject ($input: CreateProjectInput!) {
    createProject (input: $input) {
      id
      name
      color_palette
      default_button_text_color
      default_button_text_size
      default_button_font
      default_button_shape
      default_button_width_percentage
      default_button_opacity
      default_button_fit_whole_cell
      default_button_background_type
      default_button_background_image_uri
      default_button_background_color
      primary_language_code
      language_selector_shape
      language_selector_display_type
      language_selector_background_color
      language_selector_border_color
      language_selector_text_color
    }
  }`;

export const list = gql`
  {
    projects {
      id
      name
      archived_at
      devices {
        id
        name
        location
        connected
      }
    }
  }
`;

export const archived = gql`
  {
    archivedProjects {
      id
      name
      archived_at
      devices {
        id
        name
        location
        connected
      }
    }
  }
`;

export const archive = gql`
  mutation ArchiveProject ($input: ID!) {
    archiveProject (input: $input) {
      id
      name
      archived_at
    }
  }
`;

export const restore = gql`
  mutation RestoreProject ($input: ID!) {
    restoreProject (input: $input) {
      id
      name
      archived_at
    }
  }
`;

export const get = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      latest_version {
        version
        publication_date
        uri
      }
    }
  }
`;

export const getInstalls = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      device_installs {
        device_id
        version
        install_date
      }
    }
  }
`;

export const update = gql`
  mutation UpdateProject ($input: UpdateProjectInput!) {
    updateProject (input: $input) {
      id
      name
      main_page_id
      color_palette
      default_button_text_color
      default_button_text_size
      default_button_font
      default_button_shape
      default_button_width_percentage
      default_button_opacity
      default_button_fit_whole_cell
      default_button_background_type
      default_button_background_image_uri
      default_button_background_color
      primary_language_code
      language_selector_shape
      language_selector_display_type
      language_selector_background_color
      language_selector_border_color
      language_selector_text_color
      idle_timeout_seconds
      loading_image_uri
    }
  }
`;


export const getWithChildren = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      main_page_id
      color_palette
      default_button_text_color
      default_button_text_size
      default_button_font
      default_button_shape
      default_button_width_percentage
      default_button_opacity
      default_button_fit_whole_cell
      default_button_background_type
      default_button_background_image_uri
      default_button_background_color
      primary_language_code
      language_selector_shape
      language_selector_display_type
      language_selector_background_color
      language_selector_border_color
      language_selector_text_color
      default_font_ratio
      idle_timeout_seconds
      loading_image_uri
      languages {
        code
        name
        local_name
        flag_image_uri
      }
      pages {
        id
        name
      }
      fonts {
        id
        name
        uri
      }
      tab_menus {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

export const getLanguagesForProject = gql`
  query Project($id: ID!){
    project(id: $id) {
      id
      languages {
        code
        name
        local_name
        flag_image_uri
      }
    }
  }
`

export const duplicate = gql`
  mutation DuplicateProject ($input: ID!) {
    duplicateProject (input: $input) {
      id
    }
  }`;

export const getProjectWithGames = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      games {
        id
        game_type
      }
    }
  }
`

export const del = gql`
    mutation DeleteProject ($input: ID!) {
        deleteProject (input: $input) {
            id
            name
            color_palette
            default_button_text_color
            default_button_text_size
            default_button_font
            default_button_shape
            default_button_width_percentage
            default_button_opacity
            default_button_fit_whole_cell
            default_button_background_type
            default_button_background_image_uri
            default_button_background_color
            primary_language_code
            language_selector_shape
            language_selector_display_type
            language_selector_background_color
            language_selector_border_color
            language_selector_text_color
        }
    }`;

export const publishSummary = gql`
  query ProjectPublishSummary($id: ID!) {
    project(id: $id) {
      id
      name
      pages {
        id
        name
      }
      devices {
        id
        name
        location
        connected
      }
      latest_version {
        version
        publication_date
      }
    }
  }
`;

export const publicationHistory = gql`
  query ProjectPublicationHistory($id: ID!) {
    project(id: $id) {
      id
      name
      publication_history {
        version
        publication_date
        uri
      }
      device_installs {
        device_id
        version
        install_date
      }
    }
  }
`;

// Toutes les polices déjà importées dans les autres interfaces (pour les réutiliser sans les réimporter).
export const allFonts = gql`
  query AllProjectFonts {
    projects {
      id
      name
      fonts {
        id
        name
        uri
      }
    }
    archivedProjects {
      id
      name
      fonts {
        id
        name
        uri
      }
    }
  }
`;

export const publishState = gql`
  query ProjectPublishState($id: ID!) {
    project(id: $id) {
      id
      has_unpublished_changes
      latest_version {
        version
        publication_date
      }
    }
  }
`;

export const projectPagesForCopy = gql`
  query ProjectPagesForCopy($id: ID!) {
    project(id: $id) {
      id
      name
      pages {
        id
        name
      }
    }
  }
`;
